export const MenuBurger = ({ clname }) => {
    return (
        <div className={clname}>
            <svg viewBox="0 0 33 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 25H8.75M16.5 25H32M1 13H32M1 1H16.5M24.25 1H32" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

        </div>
    )
}